import {Actions, createEffect, ofType} from "@ngrx/effects";
import {inject} from "@angular/core";
import {catchError, map, mergeMap, of, take} from "rxjs";
import {Store} from "@ngrx/store";
import {FulfillmentHttpService} from "../../services/fulfillment-http.service";
import {FulfillmentActions, FulfillmentAPiActions, FulfillmentChannelActions} from "./fulfillment.action";
import {PaginatedResultModel} from "../../../../commons/angular/models/paginated-result.model";
import {FulfillmentChannelService} from "../../services/fulfillment-channel.service";
import {fulfillmentFeature} from "./fulfillment.state";
import {FulfillmentModel} from "../../../models/fulfillment.model";

export const getFulfillmentsPaginatedResult = createEffect(
  (actions$ = inject(Actions),
   fulfillmentHttpService = inject(FulfillmentHttpService)
  ) => {
    return actions$.pipe(
      ofType(FulfillmentAPiActions.getFulfillmentsPaginatedResult),
      mergeMap(payload => {
        return fulfillmentHttpService.getFulfillments(payload.page, payload.size, payload.payload).pipe(
          map((res: PaginatedResultModel<FulfillmentModel>) => {
            return FulfillmentAPiActions.getFulfillmentsPaginatedResultSuccess({paginatedResult: res})
          }),
          catchError((error: {
            message: string
          }) => of(FulfillmentAPiActions.getFulfillmentsPaginatedResultFailure({error})))
        )
      })
    );
  },
  {functional: true}
);

export const getFulfillment = createEffect(
  (actions$ = inject(Actions),
   fulfillmentHttpService = inject(FulfillmentHttpService)
  ) => {
    return actions$.pipe(
      ofType(FulfillmentAPiActions.getFulfillment),
      mergeMap(payload => {
        return fulfillmentHttpService.getFulfillment(payload.fulfillmentId, payload.expand).pipe(
          map((res: FulfillmentModel) => {
            return FulfillmentAPiActions.getFulfillmentSuccess({fulfillment: res})
          }),
          catchError((error: {
            message: string
          }) => of(FulfillmentAPiActions.getFulfillmentFailure({error})))
        )
      })
    );
  },
  {functional: true}
);


export const subscribeTasksChannels = createEffect(
  (actions$ = inject(Actions),
   fulfillmentChannelService = inject(FulfillmentChannelService),
   fulfillmentStore = inject(Store<FulfillmentModel>)) => {
    return actions$.pipe(
      ofType(FulfillmentAPiActions.getFulfillmentsPaginatedResultSuccess, FulfillmentAPiActions.getFulfillmentSuccess),
      mergeMap(() => fulfillmentStore.select(fulfillmentFeature.selectAll).pipe(take(1))),
      map((fulfillments: FulfillmentModel[]) => {
        const fulfillmentIds = fulfillments.map(f => f.id);
        fulfillmentIds.forEach(fulfillmentId => fulfillmentChannelService.subscribeById(fulfillmentId));
      })
    );
  },
  {functional: true, dispatch: false}
);

export const subscribeAllFulfillmentChannels = createEffect(
  (actions$ = inject(Actions),
   fulfillmentChannelService = inject(FulfillmentChannelService)) => {
    return actions$.pipe(
      ofType(FulfillmentChannelActions.subscribe),
      mergeMap(payload =>
        fulfillmentChannelService.getChannelsValues().pipe(
          map((notification) => {
            return FulfillmentChannelActions.notificationReceived({notification: notification})
          })
        )
      )
    );
  },
  {functional: true}
);

export const unsubscribeAllFulfillmentChannels = createEffect(
  (actions$ = inject(Actions),
   fulfillmentChannelService = inject(FulfillmentChannelService)) => {
    return actions$.pipe(
      ofType(FulfillmentChannelActions.unsubscribe, FulfillmentActions.removeAll),
      map(payload => {
          fulfillmentChannelService.unSubscribeAll();
          return FulfillmentChannelActions.unsubscribeSuccess();
        }
      )
    );
  },
  {functional: true}
);


